/**
 * API base URL. VITE_API_URL wins when set (see .env.example); otherwise dev
 * talks to the local Go API on :8092 and a production build uses the
 * same-origin `/api/v1` that nginx.conf proxies to the api container.
 */
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_URL as string | undefined) || (import.meta.env.DEV ? 'http://localhost:8092/api/v1' : '/api/v1');

/** The public deployment URL used in copy-paste examples (curl, AI agent instructions). */
export const PUBLIC_URL = ((import.meta.env.VITE_PUBLIC_URL as string | undefined) || 'https://pert.pigboiler-iot.com').replace(/\/$/, '');

/** Absolute URL of the API base as the browser sees it (API_BASE_URL may be relative, e.g. `/api/v1`). */
export function apiBaseUrl(): string {
  try {
    return new URL(API_BASE_URL, window.location.origin).toString().replace(/\/$/, '');
  } catch {
    return API_BASE_URL;
  }
}
